import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import QR from "../../../../components/QR";

type Props = {
  url: string;
};

export default function TransactionQRModal({ url }: Props) {
  const tailwind = useTailwind();
  return (
    <QR.Modal style={tailwind("items-center gap-4")}>
      <Text style={tailwind("text-center")} variant="bodySmall">
        Pídele a tu cliente que escanee el código para pagar.
      </Text>
      <QR.Code url={url} utm_campaign="transaction-details" />
    </QR.Modal>
  );
}
